var Marionette = require('backbone.marionette');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');
var PersonModel = require('../../models/person-model');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');
var domtoimage = require('dom-to-image-more');

var VillagePodiatryFormView = Marionette.View.extend({
        template: require('../../templates/med-forms/village-podiatry-form.html'),

        regions: {
            reviewerSelect: '#reviewer-select',
            orgSelect: '#organization-select'
        },

        ui: {
            content: "#village-podiatry-content",
            patientName: '#patient-name',
            patientMrn: '#patient-mrn',
            patientDob: '#patient-dob',
            daySelect: '.day-select',
            supplySelect: '.supply-select',
            comment: '#comment',
            create: "#create",

            footer: "#form-footer"
        },

        events: {
            'change @ui.patientName': 'onPatientNameChanged',
            'change @ui.patientMrn': 'onPatientMrnChanged',
            'click @ui.daySelect': 'onDaySelected',
            'click @ui.supplySelect': 'onSupplySelected',
            'change @ui.comment': 'onCommentChanged',
            'click @ui.create': 'onCreate'
        },

        childViewEvents: {
            'suggestor:selected:reviewer': 'onReviewerSelected',
            'suggestor:selected:organization': 'onOrganizationSelected'
        },

        initialize: function (options) {
            var that = this;
            that.utils = new CommonUtils();
            this.currentUser = options.currentUser;
            that.initPayload();
        },

        templateContext: function () {
            var that = this;
            return {
                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                supplies: ["Prisma or Promogran", "Sorbact WCL", "Silver Alginate",
                    "XeroForm", "Sorbian Sachet", "Hydrafera Blue",
                    "ukamed Sorbact", "Betadine", "2x2 Guaze",
                    "4x4 Gauze", "ABD Pad", "Kerlix",
                    "Ace Wrap", "Coban", "Tape",
                    "Wound Cleaner", "Saline", "Moisturizer"]
            }
        },

        initPayload: function () {
            var that = this;
            this.payload = {
                patientName: "",
                patientMrn: "",
                patientDob: null,
                days: [],
                supplies: [],
                comment: "",
                reviewer: "1770539801", // hardcode -> md with id 1770539801 as default reviewer
                organization: ""
            }
        },

        onRender: function () {
            window.document.title = "Village podiatry form";
            var that = this;
            var now = new Date();

            that.ui.patientDob.datepicker({
                format: 'mm/dd/yyyy',
                clearBtn: true
            }).on('changeDate', function (e) {
                $(this).datepicker('hide');
                that.payload.patientDob = that.utils.dateToLong(e.target.value);
            }).on('clearDate', function (e) {
                that.payload.patientDob = 0;
            });

            // hardcode -> md with id 1770539801 as default reviewer
            var allenRaphael = new PersonModel();
            allenRaphael.set("id", "1770539801");
            allenRaphael.fetch({
                success: function (resp, status, xhr) {
                    that.showReviewerSelect(resp.attributes);
                },
                error: function (error, model_, options) {
                    that.showReviewerSelect(null);
                }
            });

            that.showOrganizationSelect(null);
        },

        onPatientNameChanged: function (event) {
            this.payload.patientName = event.target.value;
        },
        onPatientMrnChanged: function (event) {
            this.payload.patientMrn = event.target.value;
        },

        onDaySelected: function (event) {
            var value = event.target.name;
            if (event.target.checked) {
                this.payload.days.push(value);
                this.payload.days = _.uniq(this.payload.days);
            } else {
                this.payload.days = this.payload.days.filter(function (day) {
                    return day !== value
                });
            }

            console.log(this.payload.days);
        },

        onSupplySelected: function (event) {
            var value = event.target.name;
            if (event.target.checked) {
                this.payload.supplies.push(value);
                this.payload.supplies = _.uniq(this.payload.supplies);
            } else {
                this.payload.supplies = this.payload.supplies.filter(function (supply) {
                    return supply !== value
                });
            }

            console.log(this.payload.supplies);
        },

        onCommentChanged: function (event) {
            this.payload.comment = event.target.value;
            console.log(this.payload);
        },

        validateForm: function () {

            if (_.isEmpty(this.payload.patientName))
                return 'Please, fill Patient Name';

            if (_.isEmpty(this.payload.reviewer)) {
                return 'Please, select Reviewer';
            }

            if (_.isEmpty(this.payload.organization)) {
                return 'Please, select Requesting Organization';
            }

            return "";
        },

        getErrorsCount: function () {
            return this.$el.find('.has-error').length;
        },

        onCreate: function () {
            var that = this;

            console.log(that.payload);
            console.log(that.ui.content);
            //console.log(that.ui.content.parent().html());

            var errorText = that.validateForm();
            if (!_.isEmpty(errorText)) {
                notificationsChannel.request('show:notification', errorText);
                return;
            }

            that.ui.footer.hide();
            that.ui.content.find('input:checkbox').each(function () {
                $(this).hide();
                if ($(this).prop('checked')) {
                    //$(this).parent().addClass('underline');
                    $(this).parent().html("<b>&#9745;</b>&nbsp;" + $(this).parent().html());
                } else {
                    $(this).parent().html("<b>&#9744;</b>&nbsp;" + $(this).parent().html());
                }
            })

            var restore = function () {
                that.ui.footer.show();
                that.ui.content.find('input:checkbox').each(function () {
                    $(this).show();
                    if ($(this).prop('checked')) {
                        //$(this).parent().addClass('underline');
                        $(this).parent().html($(this).parent().text().replaceAll("<b>&#9745;</b>&nbsp;", ""));
                    } else {
                        $(this).parent().html($(this).parent().text().replaceAll("<b>&#9744;</b>&nbsp;", ""));
                    }
                    /*if ($(this).prop('checked')) {
                        $(this).parent().removeClass('underline');
                    }*/
                })
            }

            /*domtoimage.toPng(document.getElementById('village-podiatry-content'), {
                bgcolor: '#FFFFFF',
                width: that.ui.content.parent()[0].clientWidth,
                height: that.ui.content.parent()[0].clientHeight
            }).then(function (dataUrl) {
                var img = new Image();
                img.src = dataUrl;
                document.getElementById('village-podiatry-content').appendChild(img);
            }).catch(function (error) {
                console.error('oops, something went wrong!', error);
            });

            return;*/

            that.utils.showSpinner();

            domtoimage.toPng(document.getElementById('village-podiatry-content'), {
                bgcolor: '#FFFFFF',
                width: that.ui.content.parent()[0].clientWidth,
                height: that.ui.content.parent()[0].clientHeight
            }).then(function (dataUrl) {
                $.ajax({
                    type: "POST",
                    url: '/api/village-podiatry-form/' + that.payload.organization + '/' + that.payload.reviewer + '/' + that.payload.patientName.replace(" ", "_"),
                    data: dataUrl.replace("data:image/png;base64,", ""),
                    contentType: 'text/plain',
                    statusCode: {
                        200: function (response) {
                            that.utils.hideSpinner();
                            $.notify("Form created successfully", "success");
                            Backbone.history.navigate('/documents?PERSON_REVIEW_REQUEST=' + that.payload.reviewer + '&object_status=IN_REVIEW', {trigger: true});
                        }
                    },
                    error: function (e) {
                        that.utils.hideSpinner();
                        notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                        restore();
                    }
                });
            }).catch(function (error) {
                console.error('oops, something went wrong!', error);
                that.utils.hideSpinner();
                restore();
            });
        },

        showReviewerSelect: function (selected) {
            var that = this;
            that.reviewerSelectView = new RemoteSuggesterView({
                maxNumberOfElements: 100,
                url: '/api/person/preview?page-size=' + 100
                    + '&sortby=name&like_name=~~~&object_isMd=true&object_mergeable=false',
                symbolForSearchInUrl: '~~~',
                listLocation: function (data) {
                    return data.filter(function (item) {
                        return item.object;
                    });
                },
                getValueFn: function (element) {
                    return element.name;
                },
                classes: ["form-control"],
                placeholder: "Assigned Physician",
                findSelectedIdBySelectedIndex: function (arr, index) {
                    return (arr[index] || {}).id;
                },
                tag: 'reviewer',
                defaultSelected: selected ? selected : null
            });

            that.showChildView('reviewerSelect', that.reviewerSelectView);
        },

        showOrganizationSelect: function (selected) {
            var that = this;
            that.orgSelectView = new RemoteSuggesterView({
                maxNumberOfElements: 100,
                url: '/api/organization/preview?page-size=' + 100
                    + '&sortby=name&like_name=~~~',
                symbolForSearchInUrl: '~~~',
                listLocation: function (data) {
                    return data.filter(function (item) {
                        return item.object;
                    });
                },
                getValueFn: function (element) {
                    return element.name;
                },
                classes: ["form-control"],
                placeholder: "Requesting Organization",
                findSelectedIdBySelectedIndex: function (arr, index) {
                    return (arr[index] || {}).id;
                },
                tag: 'organization',
                defaultSelected: selected ? selected : null
            });

            that.showChildView('orgSelect', that.orgSelectView);
        },

        onReviewerSelected: function (selectedId) {
            this.payload.reviewer = selectedId;
        },

        onOrganizationSelected: function (selectedId) {
            this.payload.organization = selectedId;
        },

        showError: function (jQelement, text) {
            jQelement.tooltip({title: text});
            jQelement.parent().parent().addClass('has-error has-feedback');
        },

        clearError: function (jQelement) {
            jQelement.tooltip("destroy");
            jQelement.parent().parent().removeClass('has-error has-feedback');
        }
    })
;

module.exports = VillagePodiatryFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/med-forms/village-podiatry-form.js
// module id = 518
// module chunks = 0